<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.auName" style="width: 140px;" size="small" placeholder="请输入姓名"
                        clearable></el-input>
                    <el-input v-model="formDatas.auDepartment" style="width: 140px;" size="small" placeholder="请输入部门"
                        clearable></el-input>
                    <el-select size="small" v-model="formDatas.auSex" clearable @change="partserch" placeholder="请选择性别"
                        style="width: 130px">
                        <el-option label="男" value="男" key="2"></el-option>
                        <el-option label="女" value="女" key="1"></el-option>
                    </el-select>
                    <el-select size="small" v-model="formDatas.auClothesType" clearable @change="partserch"
                        placeholder="请选择工装类型" style="width: 130px">
                        <el-option label="七件套" :value="1" key="1"></el-option>
                        <el-option label="九件套" :value="2" key="2"></el-option>
                    </el-select>
                    <el-select size="small" v-model="formDatas.acaStatus" clearable @change="partserch"
                        placeholder="请选择状态" style="width: 130px">
                        <el-option label="待采购" :value="1" key="1"></el-option>
                        <el-option label="采购中" :value="2" key="2"></el-option>
                        <el-option label="待领取" :value="3" key="3"></el-option>
                        <el-option label="已领取" :value="4" key="4"></el-option>
                        <el-option label="换货" :value="5" key="5"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-dropdown size="small" split-button type="warning" style="margin:0 10px;" @click="Out()"
                        @command="Out">
                        导出
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item style="background-color: #E6A23C;color: white;"
                                command="1">导出全部</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button type="primary" size="small" style="margin-right: 10px;"
                        @click="bulkImport = true">批量导入</el-button>
                    <el-button type="danger" size="small" style="margin-left: 10px" @click="OutTwo">生成订单</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新增工装</el-button> -->

                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="acaId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑工装' : '新增工装'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">


                            <el-form-item label="工装名称" prop="acwName">
                                <el-input v-model="form.acwName" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="工装类型" prop="acwType">
                                <el-select v-model="form.acwType" placeholder="请选择">
                                    <el-option label="七件套" :value="1"></el-option>
                                    <el-option label="九件套" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="男女" prop="acwSex">
                                <el-select v-model="form.acwSex" placeholder="请选择">
                                    <el-option label="都适合" :value="0"></el-option>
                                    <el-option label="男" :value="1"></el-option>
                                    <el-option label="女" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="默认领取数量" prop="acwNum">
                                <el-input v-model="form.acwNum" type="number" style="width: 50%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="描述" prop="acwDes">
                                <el-input v-model="form.acwDes" style="width: 100%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="图片" prop="acwImages">
                                <my-upload ref="Imgupload" @fileChange="fileChange" :filearr="fileList"
                                    @removeAfter="removeAfter" :limit="9" style="margin: 10px 5px 5px;">
                                </my-upload>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 预生成订单 -->
            <el-dialog title="订单" :visible.sync="IsOrder" width="70%" top="8vh">
                <ve-table ref="vetable"
                    v-if="OrderList.ajClothesApplyItemList && OrderList.ajClothesApplyItemList.length > 0"
                    :columns="columnsDD" :table-data="OrderList.ajClothesApplyItemList" :max-height="200"
                    :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                    :checkbox-option="checkboxOption" row-key-field-name="acaiId"
                    :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                <div v-show="OrderList.ajClothesApplyItemList && OrderList.ajClothesApplyItemList.length == 0"
                    class="empty-data">
                    暂无工装</div>

                <div v-if="OrderList.ajClothesApplyItemList && OrderList.ajClothesApplyItemList.length > 0"
                    style="margin: 20px;">
                    <el-card>
                        <el-form ref="formDD" :model="formDD" label-position="top" label-width="150px"
                            @submit.native.prevent>
                            <el-form-item label="订单标题" prop="acoTitle">
                                <el-input v-model="formDD.acoTitle" style="width: 60%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="订单日期" prop="acoDate">
                                <el-date-picker v-model="formDD.acoDate" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期" style="width: 200px;">
                                </el-date-picker>
                            </el-form-item>
                        </el-form>
                    </el-card>

                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleWorkDDClose">取 消</el-button>
                    <el-button type="primary" @click="sureworkDD">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 详情 -->
            <el-dialog title="详情" :visible.sync="IsDetail" width="70%" top="8vh">
                <div style="max-height: 700px;">
                    <el-descriptions :column="3" border :labelStyle="{
                        color: '#409EFF',
                        textAlign: 'center',
                        width: '14%',
                        fontSize: '12px'
                    }" :contentStyle="{ textAlign: 'center', width: '18%', fontSize: '12px' }">
                        <el-descriptions-item label="姓名">{{ DetailArr.auName }}</el-descriptions-item>
                        <el-descriptions-item label="性别">{{ DetailArr.auSex }}</el-descriptions-item>
                        <el-descriptions-item label="部门">{{ DetailArr.auDepartment }}</el-descriptions-item>
                        <el-descriptions-item label="工装类型">
                            <el-tag size="small">{{ DetailArr.auClothesType == 0 ? '都有' :
                        DetailArr.auClothesType == 1 ? '七件套' : '九件套' }}</el-tag>
                        </el-descriptions-item>
                        <el-descriptions-item label="状态">
                            <el-tag size="small"
                                :type="DetailArr.acaStatus == 1 ? 'danger' : DetailArr.acaStatus == 2 ? 'primary' : DetailArr.acaStatus == 3 ? 'warning' : DetailArr.acaStatus == 4 ? 'success' : 'info'">{{
                        DetailArr.acaStatus == 1 ? '待采购' : DetailArr.acaStatus == 2 ? '采购中' :
                            DetailArr.acaStatus
                                == 3 ? '待领取' : DetailArr.acaStatus == 4 ? '已领取' : '换货' }}</el-tag>
                        </el-descriptions-item>


                    </el-descriptions>
                    <div style="margin: 10px 20px;">工装</div>
                    <div style="width: 100%;">
                        <ve-table ref="vetable"
                            v-if="DetailArr.ajClothesApplyItemList && DetailArr.ajClothesApplyItemList.length > 0"
                            :columns="columnsGg" :table-data="DetailArr.ajClothesApplyItemList" :max-height="400"
                            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                            :checkbox-option="checkboxOption" row-key-field-name="acaiId"
                            :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                        <div v-show="DetailArr.ajClothesApplyItemList && DetailArr.ajClothesApplyItemList.length == 0"
                            class="empty-data">
                            暂无工装</div>
                    </div>
                </div>
            </el-dialog>
            <el-dialog :visible.sync="WorkGgShow" width="70%" top="8vh" :title="workEdit ? '编辑工装规格申请项' : '新增工装规格申请项'"
                :before-close="handleWorkGgClose">
                <el-form ref="formGg" :model="formGg" label-position="top" label-width="150px" @submit.native.prevent>
                    <el-form-item label="工装规格申请项名称" prop="acwsId">
                        <el-select v-model="formGg.acwsId" placeholder="请选择" filterable size="mini">
                            <el-option v-for="item in workGgArr || []" :label="item.acwsName" :value="item.acwsId"
                                :key="item.acwsId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleWorkGgClose">取 消</el-button>
                    <el-button type="primary" @click="sureworkGg">确 定</el-button>
                </span>
            </el-dialog>

            <!-- 批量导入 -->
            <el-dialog title="批量导入" :visible.sync="bulkImport" width="70%" :before-close="bulkImportClose"
                style="margin-left: 200px;">
                <div style="margin: 0 10px 10px;display: flex;">
                    <el-upload class="upload-demo" action="#" accept=".xlsx,.xls" :on-change="updatabulk"
                        :auto-upload="false" ref="bulk" multiple>
                        <el-button size=" medium" type="danger">点击上传</el-button>
                    </el-upload>
                    <div>
                        <el-button type="primary"
                            @click="downloadFile('https://trainapp.aojuai.com/assets/excel/clothes.xlsx', '工装申请记录模板')"
                            style="margin-left: 20%;height: 40px;">下载模板</el-button>
                    </div>
                </div>
                <div>
                    <ve-table :columns="columnsImport" :table-data="bulkData" :max-height="500" :border-x="true"
                        :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
                        :cell-style-option="cellStyleOption" style="width: 100%"
                        :virtual-scroll-option="virtualScrollOption" />
                    <div v-show="bulkData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div style="margin: 10px;font-size: 18px;" v-if="bulkData.length != 0">
                    <span style="color: #0080FF;">一共{{ importData.numAll }}条;</span>
                    <span style="color: #0E9A00;margin-left: 5px;">成功{{ importData.numSuccess }}条;</span>
                    <span style="color: red;margin-left: 5px;">失败{{ importData.numFail }}条</span>
                    <span style="color: #E6A23C;margin-left: 5px;">信息不完整{{ importData.numUnWhole }}条</span>
                </div>
                <div slot="footer" class="dialog-footer" style="width:80%; margin: 10px auto;">
                    <!-- <el-button @click="bulkImportClose">取 消</el-button> -->
                    <el-button type="success" @click="bulkImportClick">关闭</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import {
    getAjClothesApplyList, addAjClothesWare, updateAjClothesWare, deleteAjClothesApply, getAjClothesApplyDetails, getCustomAjClothesWareScaleList,
    updateCustomAjClothesApplyItem, addAjClothesWareScale, deleteAjClothesWareScale, getAjClothesOrderPreconditioning, addAjClothesOrder, uploadAjClothesApply
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            workGgArr:[],
            formDD: {
                acaIds: '',
                acoTitle: '',
                acoDate: '',
            },
            IsOrder: false,
            OrderList: [],
            columnsDD: [

                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "acwName",
                    key: "acwName",
                    title: "工装名称",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "acwsName",
                    key: "acwsName",
                    title: "规格",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "acaiNumTotal",
                    key: "acaiNumTotal",
                    title: "数量",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                // { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                // {
                //     field: "",
                //     key: "d",
                //     title: "操作",
                //     width: 200,
                //     align: "center",
                //     renderBodyCell: ({ row, column, rowIndex }, h) => {
                //         return (
                //             <span>
                //                 <el-button
                //                     size="mini"
                //                     type="text"
                //                     on-click={() => this.handleWorkGgEdit(row)}
                //                 >
                //                     编辑
                //                 </el-button>
                //                 <el-button
                //                     size="mini"
                //                     type="text"
                //                     style="color: red"
                //                     on-click={() => this.handleWorkGgDelete(row)}
                //                 >
                //                     删除
                //                 </el-button>
                //             </span>
                //         );
                //     },
                // },
            ],
            workEdit: false,
            formGg: {
                acwsId: '',
            },
            WorkGgShow: false,
            workClothesGg: [],
            columnsGg: [

                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "acwName",
                    key: "acwName",
                    title: "工装名称",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "acwsName",
                    key: "acwsName",
                    title: "规格",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "acaiNum",
                    key: "acaiNum",
                    title: "数量",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "acaiChildAcwsName",
                    key: "acaiChildAcwsName",
                    title: "子级工装规格",
                    align: "center",
                    width: 80,
                    edit: false,
                },
                {
                    field: "acaiChildStatus",
                    key: "acaiChildStatus",
                    title: "子级状态",
                    align: "center",
                    width: 80,
                    edit: false,
                },
                {
                    field: "acaiChildDes",
                    key: "acaiChildDes",
                    title: "内部交换描述",
                    align: "center",
                    width: 200,
                    edit: false,
                },
                {
                    field: "acaiType",
                    key: "acaiType",
                    title: "类型",
                    align: "center",
                    width: 70,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {row.acaiType == 2 ? (
                                    <el-tag size="mini" type="danger">
                                        更换
                                    </el-tag>
                                ) : row.acaiType == 1 ? (
                                    <el-tag size="mini" type="primary">
                                        新建
                                    </el-tag>
                                ) : (
                                    <el-tag size="mini" type="warning">
                                        内部交换
                                    </el-tag>
                                )}
                            </span>
                        )
                    },
                },
                {
                    field: "acaiStatus",
                    key: "acaiStatus",
                    title: "状态",
                    align: "center",
                    width: 100,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {row.acaiStatus == 0 ? (
                                    <el-tag size="mini" type="info">
                                        不需要
                                    </el-tag>
                                ) : row.acaiStatus == 1 ? (
                                    <el-tag size="mini" type="danger">
                                        待采购
                                    </el-tag>
                                ) : row.acaiStatus == 2 ? (
                                    <el-tag size="mini" type="primary">
                                        采购中
                                    </el-tag>
                                ) : row.acaiStatus == 3 ? (
                                    <el-tag size="mini" type="warning">
                                        待领取
                                    </el-tag>
                                ) : row.acaiStatus == 4 ? (
                                    <el-tag size="mini" type="success">
                                        已领取
                                    </el-tag>
                                ) : (
                                    <el-tag size="mini" type="info">
                                        换货
                                    </el-tag>
                                )}
                                {
                                    (row.acaiStatus == 1 || row.acaiStatus == 0) ? <el-button
                                        size="mini"
                                        type="text"
                                        style="marginLeft:15px;"
                                        on-click={() => this.handleWorkGgEdit(row)}
                                    >
                                        编辑
                                    </el-button> : " "
                                }
                            </span>

                        )
                    },
                },
                // { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                // {
                //     field: "",
                //     key: "d",
                //     title: "操作",
                //     width: 200,
                //     align: "center",
                //     renderBodyCell: ({ row, column, rowIndex }, h) => {
                //         return (
                //             <span>
                //                 <el-button
                //                     size="mini"
                //                     type="text"
                //                     on-click={() => this.handleWorkGgEdit(row)}
                //                 >
                //                     编辑
                //                 </el-button>
                //                 <el-button
                //                     size="mini"
                //                     type="text"
                //                     style="color: red"
                //                     on-click={() => this.handleWorkGgDelete(row)}
                //                 >
                //                     删除
                //                 </el-button>
                //             </span>
                //         );
                //     },
                // },
            ],
            DetailArr: '',
            acaId: '',
            IsDetail: false,
            fileList: [],
            key: 'acaId',
            dialog: false,
            edit: false,
            form: {
                acwType: '',
                acwName: '',
                acwSex: '',
                acwNum: '',
                acwDes: '',
                acwImages: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "auName",
                    key: "auName",
                    title: "申请人",
                    align: "center",
                    width: 200,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.getDetail(row.acaId)}
                                >
                                    {row.auName}
                                </el-button>

                            </span>
                        );
                    },
                },
                {
                    field: "auClothesType",
                    key: "auClothesType",
                    title: "工装类型",
                    align: "center",
                    width: 100,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <el-tag>{row.auClothesType == 0 ? '都有' : row.auClothesType == 1 ? '七件套' : '九件套'}</el-tag>
                                }
                            </span>
                        )
                    },
                },
                {
                    field: "auSex",
                    key: "auSex",
                    title: "性别",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "auDepartment",
                    key: "auDepartment",
                    title: "部门",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "acaStatus",
                    key: "acaStatus",
                    title: "状态",
                    align: "center",
                    width: 100,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {row.acaStatus == 1 ? (
                                    <el-tag size="mini" type="danger">
                                        待采购
                                    </el-tag>
                                ) : row.acaStatus == 2 ? (
                                    <el-tag size="mini" type="primary">
                                        采购中
                                    </el-tag>
                                ) : row.acaStatus == 3 ? (
                                    <el-tag size="mini" type="warning">
                                        待领取
                                    </el-tag>
                                ) : row.acaStatus == 4 ? (
                                    <el-tag size="mini" type="success">
                                        已领取
                                    </el-tag>
                                ) : (
                                    <el-tag size="mini" type="info">
                                        换货
                                    </el-tag>
                                )}
                            </span>
                        )
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {/* <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    编辑
                                </el-button> */}
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleDelete(row)}
                                >
                                    删除
                                </el-button>
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                auName: '',
                auSex: '',
                auDepartment: '',
                auClothesType: '',
                acaStatus: '',
                currentPage: 1,
                pageSize: 10,
            },

            bulkData: [],
            importData: {},
            bulkImport: false,
            virtualScrollOption: {
                // 是否开启
                enable: true,
            },
            columnsImport: [

                {
                    field: "status",
                    key: "status",
                    title: "状态",
                    width: 150,
                    align: "center",
                    fixed: 'left',
                    filter: {
                        filterList: [
                            { value: 0, label: '成功', selected: false },
                            { value: 1, label: '失败', selected: false },
                            // { value: 3, label: '信息不完整', selected: false }
                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            // console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            this.searchByNameField(labels, 'status');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameField([]);
                        },
                        // max height
                        maxHeight: 120,

                    },
                },
                {
                    field: "statusMsg",
                    key: "statusMsg",
                    title: "状态备注",
                    width: 150,
                    align: "center",
                    fixed: 'left',
                },
                {
                    field: "auDepartment",
                    key: "auDepartment",
                    title: "部门",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "auName",
                    key: "auName",
                    title: "姓名",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "auSex",
                    key: "auSex",
                    title: "性别",
                    align: "center",
                    edit: false,
                    width: 130,
                },
                {
                    field: "acaiMaleOne",
                    key: "acaiMaleOne",
                    title: "男款西装外套",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "acaiMaleTwo",
                    key: "acaiMaleTwo",
                    title: "男款西装裤子",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "acaiMaleThree",
                    key: "acaiMaleThree",
                    title: "男款衬衫",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "acaiFemaleOne",
                    key: "acaiFemaleOne",
                    title: "女款西装外套",
                    align: "center",
                    edit: false,
                    width: 130,
                },
                {
                    field: "acaiFemaleTwo",
                    key: "acaiFemaleTwo",
                    title: "女款西装裤子",
                    align: "center",
                    edit: false,
                    width: 130,
                },
                {
                    field: "acaiFemaleThree",
                    key: "acaiFemaleThree",
                    title: "女款衬衫",
                    align: "center",
                    edit: false,
                    width: 130,
                },
                {
                    field: "acaiSexOne",
                    key: "acaiSexOne",
                    title: "白T恤",
                    align: "center",
                    edit: false,
                    width: 130,
                },
                {
                    field: "acaiSexTwo",
                    key: "acaiSexTwo",
                    title: "polo衫",
                    align: "center",
                    edit: false,
                    width: 130,
                },
            ],
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        searchByNameField(labels, id) {
            this.bulkData = this.bulkDataCopy.filter(
                (x) => labels.length === 0 || labels.includes(x[id]),
            );
        },
        downloadFile(url, name) {//下载
            if (!url) {
                return
            }
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        },
        bulkImportClick() {
            this.getList()
            this.bulkImport = false;
            this.bulkData = [];
            this.bulkDataCopy = [];
            this.$refs['bulk'].clearFiles()
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjClothesApply(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data.resultList;
                this.bulkDataCopy = res.data.data.resultList;
                this.importData = res.data.data.importData;
            })
        },

        handleWorkGgDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteAjClothesWareScale({ acwsId: row.acwsId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.getDetailList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleWorkGgEdit(row) {
            this.formGg.acaiId = row.acaiId;
            this.formGg.acwsId = row.acwsId;
            getCustomAjClothesWareScaleList({ acwId: row.acwId }).then(res => {
                this.workGgArr = res.data
                this.workEdit = true;
                this.WorkGgShow = true;
            })
        },
        handleWorkGgClose() {
            this.formGg.acwsId = '';
            this.workEdit = false;
            this.WorkGgShow = false;

        },
        handleWorkDDClose() {
            this.formDD = {
                acaIds: '',
                acoTitle: '',
                acoDate: '',
            };
            this.IsOrder = false;

        },
        sureworkDD() {
            this.$confirm("是否确定要新增, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.formDD.acaIds = this.selectedRowKeysCollection.toString()
                    var newForm = JSON.parse(JSON.stringify(this.formDD));
                    addAjClothesOrder(newForm).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "新增成功!",
                            });
                            this.handleWorkDDClose()
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })

        },
        sureworkGg() {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        var newForm = JSON.parse(JSON.stringify(this.formGg));
                        updateCustomAjClothesApplyItem(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleWorkGgClose()
                                this.getDetailList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
        },
        getDetail(id) {
            this.acaId = this.formGg.acaId = id
            getAjClothesApplyDetails({ acaId: id }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
            })
        },
        getDetailList() {
            getAjClothesApplyDetails({ acaId: this.acaId }).then(res => {
                this.DetailArr = res.data;
            })
        },
        removeAfter(file) {
            const url = this.form.acwImages.findIndex(item => item === file)
            this.form.acwImages.splice(url, 1)
        },
        // 上传图片
        fileChange(file) {
            if (this.form.acwImages && this.form.acwImages.length > 0) {
                this.form.acwImages.push(...file)
            } else {
                this.$set(this.form, 'acwImages', file)
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out(command) {
            console.log(command);
            if (this.selectedRowKeysCollection.length == 0 && !command) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0 && !command) {
                console.log('开始导出', this.selectedRowKeysCollection)
                const bulkdata = {
                    exportType: 2,
                    acaIds: this.selectedRowKeysCollection.toString(),
                    ...this.formDatas
                }
                var s = qs.stringify(bulkdata);
                this.openLoading()
                var that = this
                axios({
                    method: 'post',
                    url: config.baseURL2 + '/aj-clothes-apply/exportAjClothesApply',
                    data: s,
                    // withCredentials: true,
                    timeout: 1200000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'userid': window.localStorage.getItem('userid'),
                    }
                }).then(function (res) {
                    if (res.data) {
                        that.loadings.close()
                        let a = document.createElement('a');
                        //ArrayBuffer 转为 Blob
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        a.setAttribute("href", objectUrl);
                        a.setAttribute("download", '工装申请.xlsx');
                        a.click();
                        that.$message({
                            message: "成功",
                            type: "success"
                        });

                    }
                })
            } else {
                const bulkdata = {
                    exportType: 1,
                    ...this.formDatas
                }
                var s = qs.stringify(bulkdata);
                this.openLoading()
                var that = this
                axios({
                    method: 'post',
                    url: config.baseURL2 + '/aj-clothes-apply/exportAjClothesApply',
                    data: s,
                    // withCredentials: true,
                    timeout: 1200000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'userid': window.localStorage.getItem('userid'),
                    }
                }).then(function (res) {
                    if (res.data) {
                        that.loadings.close()
                        let a = document.createElement('a');
                        //ArrayBuffer 转为 Blob
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        a.setAttribute("href", objectUrl);
                        a.setAttribute("download", '工装申请.xlsx');
                        a.click();
                        that.$message({
                            message: "成功",
                            type: "success"
                        });

                    }
                })
            }
        },
        OutTwo() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                console.log('开始导出', this.selectedRowKeysCollection)
                const bulkdata = {
                    acaIds: this.selectedRowKeysCollection.toString(),
                }
                getAjClothesOrderPreconditioning(bulkdata).then(res => {
                    if (res.data) {
                        this.$message({
                            type: "success",
                            message: "成功!",
                        });
                        this.OrderList = res.data
                        this.IsOrder = true;
                    }
                })
            }
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAjClothesApply({ acaId: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjClothesApply({ acaId: row.acaId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                this.form.acwImages = data.acwImages ? data.acwImages.split(',') : '';
                if (this.form.acwImages.length > 0) {
                    this.form.acwImages.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList, index, img)
                    })
                }
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        var newForm = JSON.parse(JSON.stringify(this.form));
                        console.log(newForm)
                        newForm.acwImages = newForm.acwImages.length > 0 ? newForm.acwImages.filter(item => typeof item === 'string').join(',') : '';
                        addAjClothesWare(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        var newForm = JSON.parse(JSON.stringify(this.form));
                        console.log(newForm)
                        newForm.acwImages = newForm.acwImages.length > 0 ? newForm.acwImages.filter(item => typeof item === 'string').join(',') : '';
                        updateAjClothesWare(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
            this.fileList = [];
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.acaId = row.acaId
                    console.log(jsonObj);
                    updateAjClothesWare(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {
            const rowKey = row[key];
            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjClothesApplyList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjClothesApplyList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjClothesApplyList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>